import { render, staticRenderFns } from "./DescriptionInsurance.vue?vue&type=template&id=998d07fa&scoped=true"
import script from "./DescriptionInsurance.vue?vue&type=script&lang=js"
export * from "./DescriptionInsurance.vue?vue&type=script&lang=js"
import style0 from "./DescriptionInsurance.vue?vue&type=style&index=0&id=998d07fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "998d07fa",
  null
  
)

export default component.exports